"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _createSvgIcon = _interopRequireDefault(require("./utils/createSvgIcon"));

var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
  fill: "none",
  d: "M0 0h24v24H0V0z"
}), _react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M2 11h14v2H2zM18 17h2v.5h-1v1h1v.5h-2v1h3v-4h-3zM18 11h1.8L18 13.1v.9h3v-1h-1.8l1.8-2.1V10h-3zM20 8V4h-2v1h1v3zM2 17h14v2H2zM2 5h14v2H2z"
}))), 'FormatListNumberedRtlTwoTone');

exports.default = _default;